import {getImagePresets} from '@util/ImageUtils';

// Image Resize Service
/**
 * ImageResizer service supports the following api
 * GetResizedImage: Provide absolute or relative image path with size and image quality; returns image path
 * GetResizedSkuImage: Provide skuId with size and image quality; returns image path
 */
var defaults = {
    type: null,
    src: '',
    width: getImagePresets( 'thumbnail' ).width,
    height: null
};

/**
 * configureImg
 * Build a configuration object with with sane defaults applied that can be used to construct a url for the ImageResizer service
 * @param {Object} options -
 *  type: imageSize keyword,
 *  src: image path on server,
 *  width: set image to width,
 *  height: set image to height
 * @returns {Object} - modified configuration
 */
function configureImg ( options = {} ) {
    const presets = options.type ? getImagePresets( options.type ) : {};
    return $.extend( {}, defaults, options, presets );
}

export default {
    /**
     * getSizedUrl
     * return src of <img /> for GetResizedImage
     * @param {Object} options - [type, width, height, quality, sku] configureImg configuration object
     * @returns {string} - url to GetResizedImage service
     */
    getSizedUrl ( options ) {
        if ( typeof options.src === 'undefined' || options.src === '' ) {
            console.warn(
                'ImageService::getSizedUrl configuration options must provide an image src string\n\r',
                'options:',
                JSON.stringify( options )
            );
        }

        // get image presets from image configurations
        const {src, width} = configureImg( options );
        return `${src}?w=${width}`;
    },

    /**
     * @deprecated - all image paths should be derived from image models consumed from graphQL api
     * getSizedSkuUrl
     * return src of <img /> for GetResizedSkuImage
     * @param {String} skuId - unique identifier for item usual format "123-"
     * @param {Object} options - [type, width, height, quality, sku] configureImg configuration object
     * @returns {string} - url to GetResizedSkuImage service
     */
    getSizedUrlForSku ( skuId, options = {} ) {
        console.error( 'ImageServices::getSizedUrlForSku is deprecated, use getSizedUrl instead' );

        // fallback to 404 image
        return null;
    }
};
